// extracted by mini-css-extract-plugin
export default {"scroll-gap":"InfiniteScrollColumn_scroll-gap__Mtlu1"};